import React, { useContext, useEffect } from 'react';
import { ControlPanelContext } from '../../data/control-panel-context/ControlPanelConf';
import { setDraggable } from '../../draggable-resizable';
import { getLabel } from '../../data/labels';

function PrintSettingsBox(props) {
	const controlPanelContext = useContext(ControlPanelContext);
	const printerSettings = controlPanelContext.printerSettings;
	
	useEffect(() =>{
		setDraggable('print-settings-dialog');
	}, []);
	
	return (
	   <div id="print-settings-dialog" className={"print-settings-dialog draggable-element bordo-tondo"} style={{left: "80%", top: "45%"}}>
            <div className="finestra-stampa-ticket-contenitore-interno">
                <div className="finestra-stampa-ticket-intestazione bordo-tondo">
                    <div>
                        <p>{getLabel('control_panel.print_settings.title')}</p>
                    </div>
                    <button onClick={() => { controlPanelContext.setStatusPrintSettingsBox('close') }}>
                        <i className="fas fa-times-circle fa-lg"></i>
                    </button>
                </div>
                <div className="printer-settings-container">
                    <div className="printer-settings-row">
                        <div className="printer-settings-row-label">{getLabel('control_panel.print_settings.automatic_print_after_save')}</div>
                        <div className="printer-settings-row-editor">
                            <input className="pointer" onChange={(e) => {controlPanelContext.toggleAutomaticPrint()} } checked={printerSettings.automaticPrint} type="checkbox" />
                        </div>
                    </div>
                    <div className="printer-settings-row">
                        <div className="printer-settings-row-label">{getLabel('control_panel.print_settings.bordered_ticket')}</div>
                        <div className="printer-settings-row-editor">
                            <input className="pointer" onChange={(e) => {controlPanelContext.toggleBorderedTicket()} } checked={printerSettings.borderedTicket} type="checkbox" />
                        </div>
                    </div>
                </div>
            </div>
		</div>
	);
}

export default PrintSettingsBox;